<template>
  <div class="logindiv">
    <div class="logo">
      <img alt="logo" src="@/assets/LOGO-MZIE-SLO-2-BARVEN.svg"  height="60">
    </div>
    <form novalidate @submit.prevent="handleSubmit(!v$.$invalid)">
      <div class="usernamediv">
        <div class="userpasspanel p-float-label p-input-icon-right">
            <i class="pi pi-envelope ikonaemail" />
            <InputText id="email" v-model="v$.username.$model" aria-describedby="email-error"/>
            <label for="email">Email*</label>
        </div>
                     
      </div>

      <div class="passdiv">

        <div class="userpasspanel p-float-label p-input-icon-right">            
            <Password id="password" v-model="v$.password.$model" toggleMask :feedback=false @keypress="changedInput" aria-describedby="email-error"/>
            <label for="password">Password*</label>
        </div>

      </div>

      <div class="errordiv">
        <small v-if="error && isChanged==false">{{ error }}</small>         
      </div>
      

      <div class="submitbutton">
        <Button :label="translated('login')" @click="handleSubmit(!v$.$invalid)" />
				<div class="col-12 donthaveaccount">
				  <a @click="createAccount">{{ translated('donthaveaccount') }}</a>
				</div>	   
        <div class="col-12 donthaveaccount">
          <a @click="goToForgotPassword">{{ translated('forgotpassword') }}</a>
        </div>     
      </div>


    </form>
  </div>
</template>

<script>
import { computed } from "vue";
import store from "@/store";
import { email, required } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import router from "@/router";

export default {
    setup: () => ({ v$: useVuelidate() }),  
    data() {
        return {
            username: '',
            password: '',
            submitted: false,
            isChanged: false,
            error: computed(() => store.state.error),
            translated: computed(() => store.getters.getTranslate)       
        }
    },
    validations() {
        return {
            username: {
                required,
                email
            },
            password: {
                required
            }
        }
    },      
    created() { 
      //console.log('LOGIN !!!')
      store.dispatch("removeErrorMessage");
    },       
    methods: {
        createAccount() {
            router.push("register");
        },   
        goToForgotPassword() {
          router.push({ name: "ForgotPassword" });
        },   
        async handleSubmit(isFormValid) {
          this.isChanged = false
            //console.log('klicem submit:' + isFormValid)
            this.submitted = true;

            if (!isFormValid) {
                return;
            }

            let model = {
                Username: this.username,
                Password: this.password
            }

            //console.log(model)
            store.dispatch("login", model);
        },
        async changedInput() {
          this.isChanged = true
        }
    }
}



</script>

<style scoped>
  .donthaveaccount {
      text-align: center;
      cursor: pointer;
  }

  form {
    background: white;
    padding: 20px;
    border-radius: 0 0 10px 10px;
  }

  form button {
    display: block;
    margin: 60px auto 0;
  }

  .logindiv .logo {
    /* background: black; */
    padding:10px;
    border-top: 2px solid white;
    border-left: 2px solid white;
    border-right: 2px solid white;
    display:flex;    
    justify-content: center;
    
  }

.userpasspanel {
    width: 100%;
}

.usernamediv {
    margin-top: 30px;
}

i.pi.pi-envelope.ikonaemail {
    top: 15px;
    right: 7px;
}
</style>
